export default __webpack_public_path__ + "static/media/provesional_restoration_upper_23_4@2x.58432683.png";